<template>
    <span v-if="pronunciation" v-html="pronunciation" :class="class_value" />
</template>

<script>

export default {
	name: 'Pronunciation',
    components: {},
    data(){
        return {
            pronunciation: ""
        }
    },
	props:{
        'value': {
            required: false,
            default: ""
        },
        'class_value': {
            required: false,
            default: "pronunciation"
        }
	},
    watch: {
        value(newValue) {
            this.pronunciation = this.getUttHtml(newValue);
        }
    },
	mounted(){
        this.pronunciation = this.getUttHtml(this.value);
	},
	methods:{
        getBlockId(name) {
            return name;
        },
        getUttHtml(value) {
            let htmlValue = "/" + this.getUttValue(value) + "/";

            return htmlValue;
        },
        replaceUttDot(p1) {
            let value = "";

            if (p1 == "y") {
                value = '<span class="underline">' + p1 + '</span>';
            } else {
                value = '<u>' + p1 + '</u>';
            }

            return value;
        },

        replaceUttColon(p1, postfixValue = '') {
            let value = "";

            if (p1 == "y") {
                value = '<span class="underline">' + p1 + '</span>' + postfixValue;
            } else {
                value = '<u>' + p1 + '</u>' + postfixValue;
            }

            return value;
        },
        getUttValue(value) {
            let uttText = (new DOMParser).parseFromString(value, "text/html").documentElement.textContent;

            if (uttText.match(/[\.|'|:]/)) {
                if (!uttText.match(/[\.,']/)) {
                    uttText = uttText.replace(
                        /(a|e|i|o|u|y|æ|ø|å):/i,
                        (match, p1) => this.replaceUttColon(p1, ':')
                    );
                }

                uttText = uttText.replace(
                    /[\.,'](a|e|i|o|u|y|æ|ø|å)/gi,
                    (match, p1) => this.replaceUttDot(p1)
                );

            } else {
                uttText = uttText.replace(
                    /(a|e|i|o|u|y|æ|ø|å)/i,
                    (match, p1) => this.replaceUttColon(p1)
                );
            }

            uttText = uttText.replace(/\\/g, "");
            uttText = uttText.replace(".", "");
            uttText = uttText.replace("'", "");
            uttText = uttText.trim();

            return uttText;
        }
    }
}
</script>
